import { useEffect } from "react";
import { useTranslation } from "../../../hooks/useTranslation";
import { CALLBACKS, triggerCallback } from "../../../utils/commonUtils";
import { getShopperCitFailureMessage } from "../../../utils/paymentOutcome";
import DlocalCardForm from "./DlocalCardForm";
import { useCheckout } from "../../../context/CheckoutContext";
import { useIframeResize } from "../../../hooks/useIframeResize";

const AltruonDlocalCardForm = ({
  formData,
  itemDetails,
  billingPlatformId,
  routingEntries,
  planId,
  platformItemDetails,
  checkoutPageConfDto,
  checkoutProcessDto,
  transparent,
  prefetchedGatewayConnection,
  tenantId,
}) => {
  const queryParams = new URLSearchParams(window.location.search);
  const sessionId = queryParams.get("session_id");
  const { t } = useTranslation();
  const { triggerPaymentEvent } = useCheckout();
  
  // Enable dynamic iframe resizing for embedded checkout
  useIframeResize({ enabled: true, padding: 40 });

  /**
   * Listen for parent window messages
   */
  useEffect(() => {
    const handleMessage = (event) => {
      if (event?.data?.type === "makePayment") {
        triggerPaymentEvent();
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [triggerPaymentEvent]);

  /**
   * Handle cardholder name and card data changes
   */
  const handleCardDataChange = (data) => {
    window.parent.postMessage(
      {
        type: "updateCardData",
        data: {
          cardholderName: data.cardholderName,
          saveCard: true,
        },
      },
      "*"
    );
  };

  const onParentCallback = (event) => {
    switch (event.type) {
      case "finalizeFormData":
        window.parent.postMessage(event, "*");
        break;

      case "actionRequired":
        triggerCallback(CALLBACKS.ACTION_REQUIRED, {
          actionType: "REDIRECT",
          redirectUrl: event.url,
          message: "Payment initiated, redirecting you to complete the process...",
        });
        break;

      case "success":
        triggerCallback(CALLBACKS.SUCCESS, {
          status: "success",
          transactionId: event.transactionId,
          message: "Payment successfully initiated.",
        });

        //Notify parent window that payment is successful
        window.parent.postMessage(
          {
            type: "paymentSuccess",
            data: { transactionId: event.transactionId },
          },
          "*"
        );
        break;

      default:
        triggerCallback(CALLBACKS.FAILURE, {
          status: "failed",
          message: getShopperCitFailureMessage(t),
        });
    }
  };

  return (
    <DlocalCardForm
      formData={formData}
      itemDetails={itemDetails}
      billingPlatformId={billingPlatformId}
      routingEntries={routingEntries}
      planId={planId}
      platformItemDetails={platformItemDetails}
      checkoutPageConfDto={checkoutPageConfDto}
      checkoutProcessDto={checkoutProcessDto}
      transparent={transparent}
      prefetchedGatewayConnection={prefetchedGatewayConnection}
      tenantId={tenantId}
      sessionId={sessionId}
      onCardDataChange={handleCardDataChange}
      onParentCallback={onParentCallback}
      isEmbeddedCheckout={true}
    />
  );
};

export default AltruonDlocalCardForm;